import { flowRight } from 'lodash';
import * as React from 'react';
import * as I18n from 'i18n-js';
import * as elog from '@reverbdotcom/commons/dist/elog';
import { graphql, MutationOpts } from 'react-apollo';
import gql from 'graphql-tag';
import Tooltip from '@reverbdotcom/commons/dist/components/tooltip';

import {
  ApolloQueryResult,
} from 'apollo-client';
import bind from '@reverbdotcom/commons/dist/bind';
import {
  DeclineFeedbackMutation,
} from '../../schemas/rql';

const COMPONENT_NAME = 'FuDeclineFeedbackllBleedHeading';

const declineFeedbackGQL = gql`
  mutation DeclineFeedbackMutation(
    $input: Input_core_apimessages_DeclineFeedbackRequest
  ) {
    declineFeedbackRequest(input: $input) {
      orderUuid
    }
  }
`;

const declineFeedbackMutation = graphql<
{},
DeclineFeedbackMutation.Mutation,
DeclineFeedbackMutation.Variables
>(declineFeedbackGQL, {
  name: 'declineFeedbackMutation',
});

interface IRQLProps {
  declineFeedbackMutation: (opts: MutationOpts) => Promise<ApolloQueryResult<
  DeclineFeedbackMutation.DeclineFeedbackRequest>>;
}

interface IOwnProps {
  orderUuid: string;
  onSuccess: Function;
}

type IProps = IRQLProps & IOwnProps;

export class DeclineFeedback extends React.Component<IProps, null> {
  @bind
  onSuccess() {
    this.props.onSuccess();
  }

  @bind
  onError(e) {
    elog.error(`DeclineFeedbackError (${COMPONENT_NAME})`, {}, e);
  }

  @bind
  declineFeedback(event) {
    event.preventDefault();
    return this.props.declineFeedbackMutation({
      variables: {
        input: {
          orderUuid: this.props.orderUuid,
        },
      },
    }).then(this.onSuccess, this.onError);
  }

  render() {
    return (
      <div>
        <span data-decline-feedback>
          <Tooltip text={I18n.t('discovery.declineFeedback.tooltip')} type="plain">
            <button className="button-as-link" onClick={this.declineFeedback} type="button" aria-label={I18n.t('discovery.declineFeedback.tooltip')}>
              <span className="fa fa-times"></span>
            </button>
          </Tooltip>
        </span>
      </div>
    );
  }
}

export default flowRight([
  declineFeedbackMutation,
])(DeclineFeedback) as React.ComponentClass<IOwnProps>;



// WEBPACK FOOTER //
// ./node_modules/@reverbdotcom/discovery-ui/src/components/feedbacks/decline_feedback.tsx